import './Sidebar.css';

import { ScrollColumnView } from '@ipfabric/ui-components/ScrollView/ScrollColumnView';
import { prop } from '@ipfabric/utils/fp/prop';
import classNames from 'classnames';
import { useGlobalStateContextSelectors } from 'components/GlobalState/GlobalStateModel';
import type { FC, ReactNode } from 'react';
import { Navigation } from './Navigation';
import { Search } from './Search/Search';
import { SidebarSnapshots } from './SidebarSnapshots';
import { SidebarToggle } from './SidebarToggle';

const ScrollContainer: FC<{
  compact: boolean;
  children: ReactNode;
}> = (props) =>
  props.compact ? (
    <>{props.children}</>
  ) : (
    <ScrollColumnView>{props.children}</ScrollColumnView>
  );

export const Sidebar: FC = () => {
  const globalStateCtxProps = useGlobalStateContextSelectors({
    minimisedMenu: prop('minimisedMenu'),
    theme: prop('user', 'theme'),
  });
  const compact = globalStateCtxProps.minimisedMenu;

  return (
    <div
      className={classNames(
        'sidebar',
        globalStateCtxProps.theme === 'dark' ? 'theme--dark' : 'theme--light',
        globalStateCtxProps.minimisedMenu && 'sidebar--collapsed',
      )}
    >
      <div className='sidebar__actions'>
        <SidebarSnapshots />
        <Search />
      </div>
      <ScrollContainer compact={compact}>
        <Navigation compact={compact} />
      </ScrollContainer>
      <SidebarToggle />
    </div>
  );
};
